import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import './bgimg.css';
import BackgroundImage from 'gatsby-background-image-es5';

export const AboutBackground: React.FC<{
  className: any,
}> = ({ className }) => {
  const {
    diver,
    diverMobi
  } = useStaticQuery(
    graphql`
      query {
        diverMobi: file(
          relativePath: { eq: "aboutbg768.jpg" }
          ) {
          childImageSharp {
            fluid(
              quality: 90,
              maxWidth: 764,
              srcSetBreakpoints: [ 414, 764 ]
            ) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        },
        diver: file(
          relativePath: { eq: "aboutbg1920.jpg" }
          ) {
          childImageSharp {
            fluid(
              quality: 90,
              maxWidth: 1920,
              srcSetBreakpoints: [768, 1024, 1440, 1920]
            ) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundFluidImageStack = [
    diverMobi.childImageSharp.fluid,
    {
      ...diver.childImageSharp.fluid,
      media: '(min-width: 769px)',
    }
  ];

  return (
    <BackgroundImage
      Tag={'section'}
      className={className}
      fluid={backgroundFluidImageStack}
      style={{
        // Defaults are overwrite-able by setting one or each of the following:
        position: 'absolute',
        backgroundPosition: 'center top',
        objectFit: 'contain',
        opacity: '1',
      }}
    >
    </BackgroundImage>
  );
};
